import { render } from "./Principal-profile.vue?vue&type=template&id=0229ce2f"
import script from "./Principal-profile.vue?vue&type=script&lang=js"
export * from "./Principal-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__